import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

//解决点击相同路由报错问题
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
export default new Router({
  // mode:"history",
  routes: [{
      path: '/codepay/:out_trade_no',
      component: () => import("@/pages/index/pay/codepay.vue"),
      meta: {
        title: window.config.pay_title
      }
    }, {
      path: '/f2fpay/:out_trade_no',
      component: () => import("@/pages/index/pay/f2fpay.vue"),
      meta: {
        title: window.config.pay_title
      }
    },
    {
      path: '/wxpay/:out_trade_no',
      component: () => import("@/pages/index/pay/wxpay.vue"),
      meta: {
        title: window.config.pay_title
      }
    },
    {
      path: '/geekpay/:out_trade_no',
      component: () => import("@/pages/index/pay/geekpay.vue"),
      meta: {
        title: window.config.pay_title
      }
    },





    {
      path: '/',
      component: () => import("@/pages/index/views/pc/header.vue"),
      children: [{
          path: '/',
          name: 'pc-home',
          component: () => import("@/pages/index/views/pc/index.vue"),
          meta: {
            title: window.config.index_title
          }
        },
        {
          path: 'details/:id',
          name: 'pc-details',
          component: () => import("@/pages/index/views/pc/details.vue"),
          meta: {
            title: window.config.details_title
          }

        },
        {
          path: 'search',
          name: 'pc-search',
          component: () => import("@/pages/index/views/pc/search.vue"),
          meta: {
            title: window.config.search_title
          }
        },
        {
          path: 'query',
          name: 'pc-query',
          component: () => import("@/pages/index/views/pc/query.vue"),
          meta: {
            title: window.config.query_title
          }
        },
        // {
        //   path: "*",
        //   redirect: '/'
        // },
      ]
    },

    {
      path: '/m',
      component: () => import("@/pages/index/views/mobile.vue"),
      children: [{
          path: '/',
          name: 'mobile-home',
          component: () => import("@/pages/index/views/mobile/index.vue"),
          meta: {
            title: window.config.index_title
          }
        },
        {
          path: 'details/:id',
          name: 'mobile-details',
          component: () => import("@/pages/index/views/mobile/details.vue"),
          meta: {
            title: window.config.details_title
          }
        },
        {
          path: 'pay',
          name: 'mobile-details',
          component: () => import("@/pages/index/views/mobile/pay.vue"),
          meta: {
            title: window.config.pay_title
          }
        },
        {
          path: 'query',
          name: 'mobile-query',
          component: () => import("@/pages/index/views/mobile/query.vue"),
          meta: {
            title: window.config.query_title
          }
        },
        {
          path: 'search',
          name: 'mobile-search',
          component: () => import("@/pages/index/views/mobile/search.vue"),
          meta: {
            title: window.config.search_title
          }
        },
        {
          path: 'group',
          name: 'mobile-group',
          component: () => import("@/pages/index/views/mobile/group.vue"),
          meta: {
            title: window.config.search_title
          }
        },
        // {
        //   path: "*",
        //   redirect: '/m'
        // },
      ]
    },
    {
      path: '/error',
      name: 'error',
      meta: {
        title: '程序未授权'
      },
      component: () => import('@/pages/error/auth')
    },
    {
      path: '*',
      name: '404',
      meta: {
        title: '404'
      },
      component: () => import('@/pages/error/404')
    }

   
  ]
})